import configSource from "../../res/config.json";
import { format } from "date-fns";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { pdfLayoutsByCountry } from "../../logic/PdfPositions";

export async function GenerateSignaturePDF(props) {
  const today = new Date();
  const formattedDate = format(today, "yyyy-MM-dd HH:mm");

  const response = await fetch(
    configSource.ROOT +
      `getimage?company=hcs&country=${props.params.lang.toLowerCase()}&type=signature_page.pdf`
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }

  const existingPdfBytes = await response.arrayBuffer();
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];

  const lang = props.params.lang.toLowerCase();
  const layout = pdfLayoutsByCountry.signature[lang].signaturePage;

  const contractNumber = props.formInformation.contractNumber || "";

  const ipResponse = await fetch("https://api.ipify.org?format=json");
  if (!ipResponse.ok) throw new Error("Failed to fetch IP");
  const ipData = await ipResponse.json();
  const userIp = ipData.ip || "N/A";

  firstPage.drawText(contractNumber, {
    x: layout.contractNumber.x,
    y: layout.contractNumber.y,
    size: layout.contractNumber.size,
    font,
    color: rgb(0, 0, 0),
  });

  firstPage.drawText(formattedDate, {
    x: layout.signatureDate.x,
    y: layout.signatureDate.y,
    size: layout.signatureDate.size,
    font,
    color: rgb(0, 0, 0),
  });
  firstPage.drawText(props.customerInformation.sellerName, {
    x: layout.sellerName.x,
    y: layout.sellerName.y,
    size: layout.sellerName.size,
    font,
    color: rgb(0, 0, 0),
  });
  firstPage.drawText(formattedDate, {
    x: layout.timeStampt.x,
    y: layout.timeStampt.y,
    size: layout.timeStampt.size,
    font,
    color: rgb(0, 0, 0),
  });

  firstPage.drawText(userIp, {
    x: layout.ip.x,
    y: layout.ip.y,
    size: layout.ip.size,
    font,
    color: rgb(0, 0, 0),
  });
  firstPage.drawText(props.customerInformation.dealerEmail, {
    x: layout.dealerEmail.x,
    y: layout.dealerEmail.y,
    size: layout.dealerEmail.size,
    font,
    color: rgb(0, 0, 0),
  });
  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
}
